import axios from 'utils/axios';

export const getNotifications = async () => {
  const response = await axios.get('/realtime/notifications/');
  return response.data;
};

export const markAsRead = async (id: number) => {
  const response = await axios.post(
    `/realtime/notifications/${id}/read/`
  );
  return response.data;
};

export const markAllAsRead = async () => {
  const response = await axios.post('/realtime/notifications/read-all/');
  return response.data;
};

export const getRealtimeConfig = async () => {
  const response = await axios.get('/realtime/config/');
  return response.data;
};
